const MS4s = () => {
  const MS4sData = [
    {
      agency: 'Arapahoe County',
      total_construction_sites: '52',
      construction_inspections_count: '507',
      construction_site_enforcement_actions: '5<sup>1</sup>',
      permanent_bmps_count: '53<sup>2</sup>',
      new_permanent_bmps_count: '1',
      inspections: '1',
      permanent_control_measures_maintained: '--',
      flood_control_facilities: '--',
    },
    {
      agency: 'Douglas County',
      total_construction_sites: '1206',
      construction_inspections_count: '6697',
      construction_site_enforcement_actions: '135',
      permanent_bmps_count: '170',
      new_permanent_bmps_count: '4',
      inspections: '5',
      permanent_control_measures_maintained: '--',
      flood_control_facilities: '--',
    },
    {
      agency: 'City of Aurora',
      total_construction_sites: '91',
      construction_inspections_count: '550',
      construction_site_enforcement_actions: '19',
      permanent_bmps_count: '27',
      new_permanent_bmps_count: '1',
      inspections: '11',
      permanent_control_measures_maintained: '--',
      flood_control_facilities: '--',
    },
    {
      agency: 'SEMSWA (City of Centennial)',
      total_construction_sites: '63',
      construction_inspections_count: '938',
      construction_site_enforcement_actions: '14<sup>1</sup>',
      permanent_bmps_count: '100<sup>2</sup>',
      new_permanent_bmps_count: '6',
      inspections: '8<sup>3</sup>',
      permanent_control_measures_maintained: '--',
      flood_control_facilities: '--',
    },
    {
      agency: 'City of Greenwood Village',
      total_construction_sites: '1',
      construction_inspections_count: '8',
      construction_site_enforcement_actions: '0',
      permanent_bmps_count: '25',
      new_permanent_bmps_count: '1',
      inspections: '25',
      permanent_control_measures_maintained: '--',
      flood_control_facilities: '--',
    },
    {
      agency: 'City of Lone Tree',
      total_construction_sites: '10',
      construction_inspections_count: '159',
      construction_site_enforcement_actions: '1',
      permanent_bmps_count: '20',
      new_permanent_bmps_count: '1',
      inspections: '20',
      permanent_control_measures_maintained: '--',
      flood_control_facilities: '--',
    },
    {
      agency: 'City of Castle Pines',
      total_construction_sites: '44',
      construction_inspections_count: '688',
      construction_site_enforcement_actions: '17',
      permanent_bmps_count: '9<sup>6</sup>',
      new_permanent_bmps_count: '0',
      inspections: '4',
      permanent_control_measures_maintained: '--',
      flood_control_facilities: '--',
    },
    {
      agency: 'Town of Castle Rock',
      total_construction_sites: '1221',
      construction_inspections_count: '3082',
      construction_site_enforcement_actions: '1193',
      permanent_bmps_count: '100',
      new_permanent_bmps_count: '8',
      inspections: '99',
      permanent_control_measures_maintained: '--',
      flood_control_facilities: '--',
    },
    {
      agency: 'Town of Parker',
      total_construction_sites: '114',
      construction_inspections_count: '1810',
      construction_site_enforcement_actions: '20',
      permanent_bmps_count: '160',
      new_permanent_bmps_count: '14',
      inspections: '336',
      permanent_control_measures_maintained: '--',
      flood_control_facilities: '--',
    },
    {
      agency: 'CDOT',
      total_construction_sites: '5<sup>4</sup>',
      construction_inspections_count: '20',
      construction_site_enforcement_actions: '0',
      permanent_bmps_count: '0<sup>5</sup>',
      new_permanent_bmps_count: '0',
      inspections: '0',
      permanent_control_measures_maintained: '--',
      flood_control_facilities: '--',
    },
  ];

  // Declare and configure request overview table
  const MS4sTable = new requestTable({
    container: '#ms4s-table',
    filterEnabled: false,
    tableHeaders: {
      agency: 'Agency',
      total_construction_sites: 'Total Construction Sites',
      construction_inspections_count: 'Construction Inspections',
      construction_site_enforcement_actions: 'Construction Site Enforcement Actions',
      permanent_bmps_count: 'Permanent BMPs',
      new_permanent_bmps_count: 'New Permanent BMPs',
      inspections: 'Inspections',
      permanent_control_measures_maintained: 'Permanent Control Measures Maintained',
      flood_control_facilities: 'Flood Control Facilities',
    },
    tableActions: [],
    tableData: MS4sData,
  });
  MS4sTable.buildTable();
};
